import { ContentType } from '@candu-ai/content/types';
import { BuiltInComponents } from 'craft/constants';

export type TooltipType = ContentType.HotspotGroup | ContentType.Tour;

export const tooltipTypeForNode = (nodeType?: string) => {
  if (nodeType === BuiltInComponents.Tour || nodeType === BuiltInComponents.TourStep) {
    return ContentType.Tour;
  }
  if (nodeType === BuiltInComponents.Hotspot || nodeType === BuiltInComponents.HotspotGroup) {
    return ContentType.HotspotGroup;
  }
  return undefined;
};
